export interface SubscriptionDetail {
    id?: number;
    type: string;
    signLimit: number;
    used: number;
    price: number;
    currency: string | null;
    identified: boolean;
}

export interface Subscriptions {
    userid: string;
    plan: string;
    credit: number;
    creditCurrency: string;
    creditUsed: number;
    paymentYearly?: boolean;
    testDuration: number;
    testStartDate: string | null;
    details: SubscriptionDetail[];
    properties?: unknown[];
}

export enum PlanType {
    STARTER = 'starter',
    BASIC = 'Basic',
    BUSINESS = 'Business',
    CUSTOM = 'Custom'
}
